import { Component, ChangeDetectorRef, DestroyRef, effect, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

import { Filter, IOption } from '../filters';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'cbre-abstract-filter',
  template: '',
})
export abstract class AbstractFilterComponent {
  readonly form = input<FormGroup>();
  readonly filter = input<Filter>();
  readonly showLabel = input(true);
  readonly removeFilter = output<any>();

  /** Backward-compatible alias for templates using filter$() */
  readonly filter$ = this.filter;

  public control: FormControl;
  public options: IOption[] = [];
  public hasClearIcon = false;

  protected _form: FormGroup;
  protected _reset$ = new Subject();
  protected cdr = inject(ChangeDetectorRef);
  protected destroyRef = inject(DestroyRef);

  protected abstract _setUpFilter(): void;
  public abstract handleChange(nextValue: any): void;

  constructor() {
    effect(() => {
      const form = this.form();
      const filter = this.filter();
      if (form) {
        this._form = form;
      }
      if (filter != null && this._form != null) {
        this._setUpFilter();
      }
    });
  }

  protected _checkValuePresence = () => {
    this.hasClearIcon = !!this.control?.value;
    this.cdr.markForCheck();
  };
}
